import { makeVar } from '@apollo/client'
import { ColumnHeaderMenuState } from 'components/AgGrid/types'

export const isProductLineColumnHeaderRightClickMenuVar = makeVar<ColumnHeaderMenuState | false>(
  false
)
